import { Component, h } from 'preact'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import Card from '../cards/index'
import Phrase from '../../libs/translationsUtils/phrase'
import { ParentCategory, Category } from '../community-category'

interface State {
  categories: Array<ParentCategory>
}

interface Props {
  selectedTemplate: number,
  title: string
}

class KnowledgeBase extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      categories: []
    }
  }

  templates = ['big-card', 'small-card']

  async componentDidMount () {
    const response = await getWithInMemoryCache('/site/knowledgeBase', {})
    this.setState({
      categories: response.categoryGroups
    })
  }

  getMetadata (categories: Array<Category>) {
    let totalTopicCount = 0

    categories.forEach(category => {
      totalTopicCount += category.topicCount
    })

    return (
      <div class='knowledge-base__card-metadata'>
        <p className='text--meta'>{ <Phrase m='Common' p='knowledge.base.articles' count={{ n: totalTopicCount.toString() }} /> }</p>
      </div>
    )
  }

  render ({ title, selectedTemplate }: Props, { categories }: State) {
    if (!categories.length) {
      return null
    }

    return (
      <section
        className='full-width Template-brand-featured homepage-widget-wrapper knowledge-base-container qa-knowledge-base-container custom-knowledge-base'>
        <div className='sitewidth'>
          <div className='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <ul className='knowledge-base-category-list'>
              {
                categories.map((category, idx) => (
                  <Card
                    customClass={`knowledge-base__card knowledge-base__card-${this.templates[selectedTemplate]}`}
                    idx={idx}
                    title={category.title}
                    metadata={this.getMetadata(category.subforums)}
                    imageSrc={category.thumbnailUrl}
                    navigation={{
                      url: category.url
                    }}
                  />
                ))
              }
            </ul>
          </div>
        </div>
      </section>
    )
  }
}

export default KnowledgeBase
